module.exports = __webpack_public_path__ + "static/media/quem-somos2.aa4791fe.png";